<app-page-header
        [title]="'Sample Category Detail Details'"
        [subtitle]="'View details of the selected detail'">
</app-page-header>

@if (detail) {
    <div class="mb-5">
    <h2>{{ detail.name }}</h2>
    <p><strong>ID:</strong> {{ detail.id }}</p>
    <p>
        <strong>Naming Relevant:</strong>
        {{ detail.isNamingRelevant ? 'Yes' : 'No' }}
    </p>
    <p>
        <strong>Created By:</strong>
        {{ detail.createdBy | roleName }}
    </p>
    <p>
        <strong>Updated By:</strong>
        {{ detail.updatedBy | roleName }}
    </p>
    </div>
}
<!-- Categories -->
<div class="mb-6">
    <h2 class="text-2xl font-semibold mb-2">Sample Categories</h2>
    <div class="border border-gray-300 dark:border-gray-700 p-4 rounded-md">
        <p-table
                [value]="categories"
                dataKey="id"
                [tableStyle]="{'min-width': '50rem'}"
                scrollable="true"
                scrollHeight="300px"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>Name</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-category>
                <tr>
                    <td>{{ category.name }}</td>
                    <td>
                        <div class="flex justify-end">
                            <p-button
                                    canManageSampleDefinitions
                                    [hidden]="false"
                                    text
                                    icon="pi pi-minus"
                                    severity="danger"
                                    pTooltip="Remove category"
                                    tooltipPosition="left"
                                    (click)="removeCategory(category)">
                            </p-button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
        <p-button [hidden]="false" class="mt-5" icon="pi pi-plus" canManageSampleDefinitions label="Assign Sample Categories"
                  (click)="this.openSetSampleCategoriesDialog()"></p-button>
    </div>
</div>
<div class="flex justify-between gap-2">
    <div>
        <p-button
                canManageSampleDefinitions
                label="Edit"
                icon="pi pi-pencil"
                (click)="openEditDialog()"
                text>
        </p-button>
        <p-button
                canManageSampleDefinitions
                label="Delete"
                icon="pi pi-trash"
                (click)="confirmDelete()"
                severity="danger"
                text>
        </p-button>
    </div>
    <p-button
            label="Back to Details"
            icon="pi pi-arrow-left"
            routerLink="/details">
    </p-button>
</div>

<!-- Update Dialog -->
<app-update-detail-dialog
        [(visible)]="displayUpdateDialog"
        [detail]="editableDetail"
        (detailUpdated)="reloadDetail()">
</app-update-detail-dialog>

<!-- Set Sample Categories Dialog -->
<app-set-sample-categories-dialog
        [(visible)]="displaySetCategoriesDialog"
        [detail]="detail"
        (saved)="this.loadCategories()">
</app-set-sample-categories-dialog>
